/*
    此文件为数据接口存放命名，为防止接口太多，造成接口混乱
    命名为大写斜杠
    按页面划分
    例如： 'ORDER_API': '/api/order',
    每个接口注释用途，为方面其他开发人员查找，了解。
    export default {

    } 
*/
export default {
  /*获取公司列表*/
  GET_COMPANY_LIST_API: '/maindata/role/listCompanyCombox',
  /*获取应用名列表*/
  GET_APP_LIST_API: '/maindata/role/listApplicationCombox',
  /**获取列表 */
  GET_LIST_API: '/maindata/role/listRoles',
  /**新增角色 */
  ADD_ROLE_API: '/maindata/role/saveRole',
  // 修改角色详情
  UPDATE_ROLE_API: '/maindata/role/updateRole',
  /**删除角色详情 */
  DELETE_ROLE_API: '/maindata/role/deleteRole',
  /**获取已有按钮*/
  GET_DEFALUT_LIST: '/maindata/role/listRoleMenuBtns',
  /**菜单授权 */
  ADD_AUTH_ROLE_API: '/maindata/role/saveRoleMenuBtn',
};
